import { useRef } from "react";
import { Paperclip, X } from "lucide-react";
import { toast } from "sonner";

const ACCEPT = "image/jpeg,image/png,image/webp,image/heic,application/pdf";

export default function FilePick({ file, onFile, testid, label = "Attach photo or PDF" }) {
  const ref = useRef(null);
  const pick = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (f.size > 10 * 1024 * 1024) {
      toast.error("File must be 10 MB or smaller.");
      return;
    }
    onFile(f);
  };
  return (
    <div className="inline-flex items-center gap-2 min-w-0 max-w-full">
      <input ref={ref} type="file" accept={ACCEPT} onChange={pick} className="hidden" data-testid={`${testid}-input`} />
      {file ? (
        <span className="inline-flex items-center gap-2 text-xs border border-[#262626] px-2 min-h-[36px] min-w-0 max-w-full" data-testid={`${testid}-chosen`}>
          <Paperclip size={12} className="shrink-0" /> <span className="truncate">{file.name}</span>
          <button type="button" onClick={() => onFile(null)} aria-label="Remove attachment" data-testid={`${testid}-remove`} className="shrink-0 hover:text-[#F87171]"><X size={13} /></button>
        </span>
      ) : (
        <button type="button" onClick={() => ref.current?.click()} data-testid={`${testid}-button`}
          className="min-h-[36px] px-3 border border-[#262626] hover:border-white text-xs text-white inline-flex items-center gap-1.5 transition-colors">
          <Paperclip size={13} /> {label}
        </button>
      )}
    </div>
  );
}
